import { useDispatch, useSelector } from "react-redux";
import { setGalleryForm, setGeneralInfoForm, setMyGarageMultipleFields, setQuestionareForm, setSpecificationsForm } from "../../../../../toolkit/myGarage/myGarageSlice";
import { setSellMyCarFormsHandler } from "../../../../../utils/methods/setSellMyCarForms";
import { reducerPaths } from "../../../../../app/reducerPaths";

const useSetupEditCarHandler = () => {

  const dispatch = useDispatch();

  const myGarage = useSelector((store) => store[reducerPaths.myGarage]);

  const setupEditCarHandler = (car, cb) => {
    setSellMyCarFormsHandler({
      dispatch,
      data: {
        vehicle: car,
      },
      setGeneralInfoForm: setGeneralInfoForm,
      setQuestionareForm: setQuestionareForm,
      setSpecificationsForm: setSpecificationsForm,
      setGalleryForm: setGalleryForm,
      forms: myGarage?.forms,
      previouslySubmittedForms: myGarage?.previouslySubmittedForms,
    });
    dispatch(
      setMyGarageMultipleFields({
        isEditing: true,
        areEditFormsSet: true,
        vehicle_id: car?.Vehicle_Id,
      })
    );

    if (cb) {
      cb(car);
    }
    // dispatch(setActiveStep(MyGarageSteps[0]));
    // setPageTab(pageTabs?.sellNewCar);
  };

  return {
    setupEditCarHandler
  };
};

export {
  useSetupEditCarHandler
};